import styles from './featuresBlock.module.scss'

export const FeaturesBlock = () => {
  return (
    <ul className={styles.featuresBlock}>
      <li className={styles.featuresBlock__card}>
        <img src="/static/img/icons/image.svg" alt={''} className={styles.featuresBlock__icon} />
        <div className={styles.featuresBlock__text}>
          Up to 25-40%
          <br /> off online fares
        </div>
      </li>
      <li className={styles.featuresBlock__card}>
        <img src="/static/img/icons/image.svg" alt={''} className={styles.featuresBlock__icon} />
        <div className={styles.featuresBlock__text}>
          Phone-special
          <br />
          deals
        </div>
      </li>
      <li className={styles.featuresBlock__card}>
        <img src="/static/img/icons/image.svg" alt={''} className={styles.featuresBlock__icon} />
        <div className={styles.featuresBlock__text}>All destinations</div>
      </li>
    </ul>
  )
}
